module.exports = __webpack_public_path__ + "img/cpany21.cea0bc3d.png";